module.exports = __webpack_public_path__ + "static/media/logo.afdd8b1f.svg";